module.exports = __webpack_public_path__ + "img/info_circle.ae1b803e.svg";